import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Select,
  Avatar,
  MenuItem,
  InputLabel,
  FormControl,
  IconButton,
  Snackbar,
  Alert,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  DialogActions,
  TableRow,
  TableHead,
  Tabs,
  Typography,
  TableContainer,
  Tab,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Navbar from "../Navbar/Navbar";
import { useCarrito } from "../context/CarritoContext";
import { useMediaQuery } from "@mui/material";
import { useMemo } from "react";
import Cookies from "js-cookie";
import { Switch, FormControlLabel } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import PaidIcon from "@mui/icons-material/Paid";
import * as XLSX from "xlsx";
import DownloadIcon from "@mui/icons-material/Download";
import dayjs from "dayjs";
import CustomCarousel from "./CustomCarousel.js";
import CloseIcon from "@mui/icons-material/Close";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";

const Inventario = () => {
  const fechaActual = dayjs();
  const { rol } = useCarrito();
  const [rows, setRows] = useState([]);
  const [sucursalesPermitidas, setSucursalesPermitidas] = useState([]);
  const isMobile = useMediaQuery("(max-width:900px)");
  const mapa_sucursales = {
    "CEDIS GUADALAJARA": 1,
    "BODEGA CALVILLO": 2,
    "BODEGA DURANGO": 3,
    "BODEGA RINCON": 4,
    "SUC GALERIAS": 5,
    "SUC GDL LOPEZ MATEOS": 6,
    "SUC GDL MARIANO OTERO": 7,
    "SUC GUADALAJARA": 8,
    "SUC GUADALUPE": 9,
    "SUC LEON": 10,
    "SUC MATRIZ": 11,
    "SUC NORTE": 12,
    "SUC ORIENTE": 13,
    "SUC PASEOS": 14,
    "SUC PUERTO VALLARTA": 15,
    "SUC SUR": 16,
    "SUC ZACATECAS": 17,
  };
  const [modalOpen, setModalOpen] = useState(false);
  const [modalExternoOpen, setModalExternoOpen] = useState(false);
  const [detalleInventario, setDetalleInventario] = useState([]);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  const OtrasMarcas = Cookies.get("OtrasMarcas");
  const VerSucursales = Cookies.get("VerSucursales");
  const IdUsuario = Cookies.get("IdUsuario");
  const PrecioHankook = Cookies.get("PrecioHankook");
  const ClaEnlaceMichelin = localStorage.getItem("ClaEnlaceMichelin");
  const Telefono = localStorage.getItem("Telefono");
  const VerCampanaExtras = Cookies.get("CampanaExtras");
  const Zona = Cookies.get("Facturacion");
  const [soloDisponibles, setSoloDisponibles] = useState(false);
  const [productoMayoreo, setProductoMayoreo] = useState(null);
  const [mto, setMto] = useState(null);
  const [modalNegarOpen, setModalNegarOpen] = useState(false);
  const [productoANegar, setProductoANegar] = useState(null);
  const [cantidadNegada, setCantidadNegada] = useState(1);
  const [productoCampana, setProductoCampana] = useState(null);
  const [productoBonificacion, setProductoBonificacion] = useState(null);
  const [filtroBonificacion, setFiltroBonificacion] = useState(false);
  const [productoPreciosLista, setProductoPreciosLista] = useState(null);
  const rutaTarjeta = localStorage.getItem("Tarjeta");
  const [clienteProdNegado, setClienteProdNegado] = useState("");
  const [gamaActual, setGamaActual] = useState("");
  const [tabIndex, setTabIndex] = useState(0);
  const [modalDetalleOpen, setModalDetalleOpen] = useState(false);
  const [inventarioExterno, setInventarioExterno] = useState(null);
  const [loadingExterno, setLoadingExterno] = useState(false);
  const [modalCampanaEmergenteOpen, setModalCampanaEmergenteOpen] =
    useState(false);
  const [switchesCampana, setSwitchesCampana] = useState({});
  const { agregarAlCarrito } = useCarrito();
  const [marcasDisponibles, setMarcasDisponibles] = useState([]);
  const [invMichelin, setInvMichelin] = useState(false);
  const [invNobhex, setInvNobhex] = useState(false);
  const [liquidacionMichelin, setLiquidacionMichelin] = useState(false);
  const [campana50Asociados, setCampana50Asociados] = useState(false);
  const [campanaBonificacionAsociados, setCampanaBonificacionAsociados] =
    useState(false);
  const [productosBonificacion, setProductosBonificacion] = useState([]);
  const [ventas, setVentas] = useState([]);
  const rolesPermitidosEspecial4 = [
    "Direccion",
    "Administracion",
    "Asesor",
    "Gerente",
  ];
  const tienePermisoEspecial4 = rolesPermitidosEspecial4.includes(rol);
  const [filters, setFilters] = useState({
    marca: "",
    ancho: "",
    alto: "",
    rin: "",
    MSPN: "",
    sucursalId: "",
    gama: "",
  });
  const [alerta, setAlerta] = useState({
    open: false,
    mensaje: "",
    tipo: "success",
  });

  const codigosApiMichelin = [
    "00264",
    "00380",
    "00793",
    "00832",
    "00862",
    "00958",
    "01088",
    "01174",
    "01201",
    "01281",
    "01286",
    "01313",
    "01327",
    "01359",
    "01577",
    "01589",
    "01614",
    "01771",
    "01931",
    "01983",
    "02262",
    "02300",
    "02344",
    "02623",
    "02657",
    "02685",
    "02987",
    "03149",
    "03393",
    "03527",
    "03637",
    "03644",
    "03744",
    "03769",
    "03815",
    "04032",
    "04034",
    "04253",
    "04357",
    "04374",
    "04778",
    "04935",
    "04997",
    "05034",
    "05192",
    "05271",
    "05325",
    "05372",
    "05396",
    "05614",
    "05707",
    "05788",
    "05825",
    "05902",
    "06016",
    "06073",
    "06260",
    "06280",
    "06367",
    "06447",
    "06449",
    "06518",
    "06599",
    "06644",
    "06890",
    "06926",
    "06948",
    "07003",
    "07069",
    "07074",
    "07111",
    "07213",
    "07218",
    "07389",
    "07493",
    "07789",
    "07913",
    "07934",
    "08022",
    "08056",
    "08385",
    "08522",
    "08557",
    "08763",
    "08781",
    "09052",
    "09129",
    "09183",
    "09209",
    "09483",
    "09656",
    "09725",
    "09881",
    "09883",
    "10009",
    "10080",
    "10165",
    "10261",
    "10300",
    "10325",
    "10365",
    "10412",
    "10496",
    "10522",
    "10526",
    "10703",
    "10867",
    "10905",
    "11175",
    "11294",
    "11397",
    "11435",
    "11527",
    "11781",
    "11782",
    "11800",
    "12049",
    "12182",
    "12353",
    "12750",
    "12877",
    "12981",
    "13041",
    "13079",
    "13092",
    "13251",
    "13534",
    "13840",
    "13871",
    "13881",
    "14015",
    "14025",
    "14189",
    "14196",
    "14885",
    "15052",
    "15324",
    "15702",
    "15794",
    "15814",
    "15830",
    "15903",
    "16183",
    "16309",
    "16411",
    "16460",
    "16639",
    "16689",
    "16932",
    "17087",
    "17109",
    "17137",
    "17219",
    "17286",
    "18126",
    "18333",
    "18478",
    "18580",
    "19443",
    "19451",
    "19555",
    "19577",
    "19599",
    "19605",
    "19808",
    "20037",
    "20152",
    "20173",
    "20409",
    "20432",
    "20617",
    "20639",
    "20817",
    "20820",
    "20855",
    "21039",
    "21408",
    "21554",
    "21565",
    "21574",
    "21747",
    "21842",
    "22311",
    "22320",
    "22358",
    "23173",
    "23270",
    "23371",
    "23431",
    "23507",
    "23549",
    "23693",
    "23743",
    "24156",
    "24420",
    "24541",
    "24663",
    "24727",
    "24952",
    "25083",
    "25373",
    "25528",
    "25585",
    "25603",
    "25722",
    "26061",
    "26070",
    "26409",
    "26672",
    "26964",
    "27075",
    "27353",
    "27354",
    "27428",
    "27439",
    "27459",
    "28170",
    "28346",
    "28484",
    "28742",
    "28897",
    "29409",
    "29567",
    "29621",
    "29715",
    "29960",
    "29964",
    "30209",
    "30234",
    "30260",
    "30479",
    "30693",
    "30771",
    "30939",
    "31010",
    "31169",
    "31259",
    "31887",
    "31951",
    "31973",
    "32357",
    "32390",
    "32455",
    "32592",
    "32617",
    "33069",
    "33095",
    "33112",
    "33172",
    "33200",
    "33323",
    "33572",
    "33611",
    "33658",
    "33720",
    "33791",
    "33799",
    "33905",
    "33976",
    "34161",
    "34167",
    "34388",
    "34457",
    "34846",
    "34879",
    "34883",
    "34965",
    "35413",
    "35549",
    "35654",
    "35726",
    "35787",
    "35915",
    "36022",
    "36312",
    "36326",
    "36394",
    "36416",
    "36513",
    "36658",
    "36773",
    "37003",
    "37009",
    "37028",
    "37033",
    "37549",
    "37587",
    "37675",
    "37853",
    "37892",
    "37907",
    "38029",
    "38063",
    "38082",
    "38261",
    "38282",
    "38287",
    "38645",
    "38827",
    "38860",
    "39001",
    "39056",
    "39299",
    "39527",
    "39562",
    "39661",
    "39694",
    "39717",
    "39750",
    "39823",
    "40116",
    "40211",
    "40640",
    "40782",
    "41519",
    "41526",
    "42284",
    "42869",
    "42911",
    "43025",
    "43081",
    "43501",
    "43808",
    "44019",
    "44044",
    "44329",
    "44391",
    "44468",
    "44873",
    "44926",
    "44929",
    "44945",
    "45912",
    "47518",
    "47973",
    "48131",
    "48442",
    "48719",
    "49531",
    "49739",
    "50153",
    "50779",
    "50946",
    "51064",
    "51097",
    "51139",
    "51200",
    "51405",
    "51646",
    "51810",
    "52157",
    "52872",
    "52924",
    "53322",
    "53473",
    "53738",
    "54332",
    "54620",
    "55288",
    "56237",
    "56400",
    "56577",
    "57267",
    "57280",
    "57304",
    "57716",
    "58070",
    "58075",
    "58242",
    "59310",
    "59321",
    "59444",
    "59499",
    "59614",
    "59641",
    "59682",
    "59800",
    "59874",
    "60558",
    "61368",
    "61823",
    "62023",
    "62547",
    "62677",
    "62899",
    "63342",
    "63760",
    "63964",
    "64261",
    "64280",
    "64338",
    "65323",
    "65330",
    "65637",
    "65724",
    "65998",
    "66893",
    "66901",
    "66946",
    "67256",
    "67400",
    "67462",
    "67497",
    "67637",
    "68293",
    "68444",
    "69212",
    "69230",
    "69343",
    "69401",
    "69713",
    "69859",
    "70264",
    "70568",
    "70968",
    "71282",
    "71509",
    "71527",
    "71904",
    "71931",
    "71948",
    "72239",
    "72714",
    "72844",
    "72898",
    "72901",
    "73134",
    "73184",
    "73361",
    "73430",
    "73712",
    "74866",
    "74995",
    "75045",
    "75183",
    "75198",
    "75495",
    "76070",
    "76155",
    "76950",
    "77143",
    "77368",
    "77605",
    "78123",
    "78163",
    "78199",
    "78900",
    "79153",
    "79569",
    "79572",
    "79600",
    "79683",
    "79734",
    "79827",
    "79871",
    "80270",
    "80655",
    "80913",
    "81038",
    "81332",
    "81507",
    "81746",
    "82059",
    "82561",
    "82566",
    "82637",
    "82875",
    "83033",
    "83054",
    "83286",
    "83425",
    "84035",
    "84125",
    "84454",
    "84948",
    "85024",
    "85328",
    "85467",
    "85538",
    "85587",
    "85765",
    "85914",
    "86150",
    "86440",
    "86594",
    "86800",
    "86882",
    "87416",
    "87451",
    "87490",
    "87581",
    "87996",
    "88058",
    "88142",
    "88176",
    "88627",
    "89284",
    "89335",
    "90757",
    "90855",
    "91214",
    "91459",
    "91644",
    "91718",
    "91762",
    "91786",
    "91897",
    "91993",
    "92622",
    "92632",
    "93363",
    "93452",
    "93920",
    "94112",
    "94380",
    "94455",
    "94732",
    "95379",
    "95455",
    "95712",
    "96128",
    "96232",
    "96583",
    "97350",
    "97351",
    "97410",
    "98364",
    "98512",
    "98871",
    "98884",
    "00905",
    "07977",
    "09444",
    "09657",
    "14063",
    "19014",
    "19912",
    "21254",
    "23815",
    "26521",
    "29378",
    "29598",
    "56422",
    "59120",
    "59371",
    "61155",
    "64354",
    "67476",
    "74126",
    "76245",
    "79805",
    "91283",
    "01047",
    "01719",
    "01898",
    "02788",
    "03963",
    "04082",
    "05846",
    "06434",
    "07847",
    "11882",
    "12514",
    "14364",
    "17722",
    "18060",
    "18290",
    "19117",
    "19405",
    "20879",
    "26547",
    "28925",
    "29399",
    "29668",
    "31435",
    "32767",
    "34341",
    "35860",
    "38937",
    "39545",
    "40410",
    "41617",
    "42263",
    "45895",
    "46828",
    "47718",
    "49388",
    "52636",
    "55937",
    "58141",
    "58194",
    "60239",
    "61319",
    "64691",
    "65865",
    "66400",
    "75567",
    "78845",
    "92730",
    "92893",
    "93943",
    "94228",
    "94916",
  ];

  const campanaActivas = [
    {
      Nombre: "VENTA ESPECIAL POR 50 ANIVERSARIO",
      Inicio: "2026-09-01",
      Fin: "2026-09-33",
      Value: 1,
    },
    ...(OtrasMarcas === "1"
      ? [
          {
            Nombre: "ESPECIAL MULTIMARCA",
            Inicio: "2026-09-01",
            Fin: "2026-09-30",
            Value: 4,
          },
        ]
      : []),
  ];
  const banners = [
    ...(OtrasMarcas === "1" ? [{ url: "/banner-promocionesSep.png" }] : []),
    { url: "/banner-aniversario.png" },
    ...(OtrasMarcas === "1"
      ? [{ url: "banner-nobhex.png" }, { url: "banner-multimarcav2.png" }]
      : []),
  ];
  const imagenesGama = [
    {
      gama: "ENERGY XM2+",
      url: "/assets/img/michelin/AUTO y CROSSOVER/energy tm xm2+.png",
    },
    {
      gama: "PRIMACY 4+",
      url: "/assets/img/michelin/AUTO y CROSSOVER/pilot primacy tm4+.png",
    },
    {
      gama: "PILOT SPORT 4S",
      url: "/assets/img/michelin/AUTO y CROSSOVER/pilot sport 4s.png",
    },
    {
      gama: "PILOT SPORT CUP 2",
      url: "/assets/img/michelin/AUTO y CROSSOVER/pilot sport cup2.png",
    },
    {
      gama: "PILOT SPORT PS2",
      url: "/assets/img/michelin/AUTO y CROSSOVER/pilot sport ps2.png",
    },
    {
      gama: "PILOT SPORT 3",
      url: "/assets/img/michelin/AUTO y CROSSOVER/pilot sport3.png",
    },
    {
      gama: "PILOT SPORT 4S",
      url: "/assets/img/michelin/AUTO y CROSSOVER/pilot sport4.png",
    },
    {
      gama: "PILOT SPORT 5",
      url: "/assets/img/michelin/AUTO y CROSSOVER/pilot sport5.png",
    },
    {
      gama: "PILOT SUPER SPORT",
      url: "/assets/img/michelin/AUTO y CROSSOVER/pilot super sport.png",
    },
    {
      gama: "PRIMACY 3",
      url: "/assets/img/michelin/AUTO y CROSSOVER/primacy tm3.png",
    },
    {
      gama: "PRIMACY 4",
      url: "/assets/img/michelin/AUTO y CROSSOVER/primacy tm4.png",
    },
    {
      gama: "AGILIS 3",
      url: "/assets/img/michelin/camioneta Comercial/AGILIS 3.png",
    },
    {
      gama: "AGILIS CC",
      url: "/assets/img/michelin/camioneta Comercial/AGILIS CROSSCLIMATE.png",
    },
    {
      gama: "DEFENDER 2",
      url: "/assets/img/michelin/SUV y camioneta/DEFENDER 2.png",
    },
    {
      gama: "DEFENDER LTX M/S",
      url: "/assets/img/michelin/SUV y camioneta/DEFENDER LTX MS.png",
    },
    {
      gama: "DEFENDER LTX M/S 2",
      url: "/assets/img/michelin/SUV y camioneta/DEFENDER LTX MS2.png",
    },
    {
      gama: "LATITUDE SPORT 3",
      url: "/assets/img/michelin/SUV y camioneta/LATITUD SPORT3.png",
    },
    {
      gama: "LATITUDE TOUR HP",
      url: "/assets/img/michelin/SUV y camioneta/LATITUDE SPORT HP.png",
    },
    {
      gama: "LATITUDE SPORT",
      url: "/assets/img/michelin/SUV y camioneta/LATITUDE SPORT.png",
    },
    {
      gama: "LTX A/T 2",
      url: "/assets/img/michelin/SUV y camioneta/LTX AT2.png",
    },
    {
      gama: "LTX FORCE",
      url: "/assets/img/michelin/SUV y camioneta/LTX FORCE.png",
    },
    {
      gama: "PILOT SPORT 4 SUV",
      url: "/assets/img/michelin/SUV y camioneta/PILOT SPORT 4 SUV.png",
    },
    {
      gama: "PRIMACY SUV+",
      url: "/assets/img/michelin/SUV y camioneta/PRIMACY tm SUV+.png",
    },
    {
      gama: "COMMERCIAL T/A",
      url: "/assets/img/BF GOODRICH/IMAGENES CARRUCEL/COMERCIAL/COMMERCIAL TA ALL SEASON 2.png",
    },
    {
      gama: "ADVANTAGE T/A DRIVE",
      url: "/assets/img/BF GOODRICH/IMAGENES CARRUCEL/PERFORMANCE TOURIG/ADVANCE TA DRIVE.png",
    },
    {
      gama: "ADVANTAGE CONTROL",
      url: "/assets/img/BF GOODRICH/IMAGENES CARRUCEL/PERFORMANCE TOURIG/ADVANTAGE CONTROL.png",
    },
    {
      gama: "RADIAL T/A",
      url: "/assets/img/BF GOODRICH/IMAGENES CARRUCEL/PERFORMANCE TOURIG/RADIAL TA.png",
    },
    {
      gama: "ADVANTAGE CONTROL",
      url: "/assets/img/BF GOODRICH/IMAGENES CARRUCEL/RECREATIONAL OFF ROAD/ADVANTAGE CONTROL.png",
    },
    {
      gama: "ALL TERRAIN T/A KO2",
      url: "/assets/img/BF GOODRICH/IMAGENES CARRUCEL/RECREATIONAL OFF ROAD/ALL TERRAIN TA KO2.png",
    },
    {
      gama: "MUD TERRAIN T/A KM3",
      url: "/assets/img/BF GOODRICH/IMAGENES CARRUCEL/RECREATIONAL OFF ROAD/MUD TERRAIN TA KM3.png",
    },
    {
      gama: "ADVANTAGE T/A SUV",
      url: "/assets/img/BF GOODRICH/IMAGENES CARRUCEL/RECREATIONAL ON ROAD/ADVANTAGE TA SUV.png",
    },
    {
      gama: "TRAIL TERRAIN T/A",
      url: "/assets/img/BF GOODRICH/IMAGENES CARRUCEL/RECREATIONAL ON ROAD/TRAIL TERRAIN TA.png",
    },
    {
      gama: "LAREDO AWT3",
      url: "/assets/img/UNIROYAL/IMAGENES CARRUCEL/PASAJEROS/LAREDO AWT 3.png",
    },
    {
      gama: "TIGER PAW AWP II",
      url: "/assets/img/UNIROYAL/IMAGENES CARRUCEL/PASAJEROS/TIGER PAW AWP2 AWP.png",
    },
    {
      gama: "TIGER PAW TOURING A/S",
      url: "/assets/img/UNIROYAL/IMAGENES CARRUCEL/PASAJEROS/TIGER PAW TOURING AS.png",
    },
    {
      gama: "LAREDO AWT3",
      url: "/assets/img/UNIROYAL/IMAGENES CARRUCEL/SUV CAMIONETA/AWT3.png",
    },
    {
      gama: "LAREDO CROSS COUNTRY TOUR",
      url: "/assets/img/UNIROYAL/IMAGENES CARRUCEL/SUV CAMIONETA/LAREDO CROSS CONTRY TOUR.png",
    },
    {
      gama: "LAREDO CROSS COUNTRY",
      url: "/assets/img/UNIROYAL/IMAGENES CARRUCEL/PASAJEROS/LAREDO CROSS COUNTRY.png",
    },
    {
      gama: "LAREDO HD/H",
      url: "/assets/img/UNIROYAL/IMAGENES CARRUCEL/VEHICULOS COMERCIALES/LAREDO HD H.png",
    },
    {
      gama: "LAREDO HD/T",
      url: "/assets/img/UNIROYAL/IMAGENES CARRUCEL/VEHICULOS COMERCIALES/LAREDO HD T.png",
    },
    { gama: "GHADE MT", url: "/assets/img/NOBHEX/GHADE MT.png" },
    { gama: "JAYGUEY", url: "/assets/img/NOBHEX/JAYGUEY.png" },
    { gama: "KHAMINO", url: "/assets/img/NOBHEX/KHAMINO.png" },
    { gama: "OKHYSE R/T", url: "/assets/img/NOBHEX/OKHYSERH.png" },
    { gama: "QHUALI", url: "/assets/img/NOBHEX/QHUALI.png" },
    { gama: "THOKO X/T", url: "/assets/img/NOBHEX/THOKO XT.png" },
    { gama: "THRAC", url: "/assets/img/NOBHEX/THRAC.png" },
  ];

  // Buscamos si existe la imagen en nuestro array
  const imagenEncontrada = imagenesGama.find(
    (item) => item.gama === gamaActual,
  );

  // Función para manejar el cambio de los switches de campaña
  const handleSwitchChange = (nombre) => (event) => {
    setSwitchesCampana({
      ...switchesCampana,
      [nombre]: event.target.checked,
    });
  };

  // Función para suscribirse a notificaciones push
  async function subscribeUser() {
    const registration = await navigator.serviceWorker.ready;

    const existingSubscription =
      await registration.pushManager.getSubscription();

    if (existingSubscription) {
      await existingSubscription.unsubscribe();
      console.log("Suscripción antigua eliminada");
    }

    const vapidPublicKey =
      "BBV3C9uw9GiBZsiOjP-GVTGbQoOURbBd-1ZNhPlPc8Y0-yY9JxykpOHqgdYa8KtjhOMbQUlnUlSvzIewCYBr5tM";

    const applicationServerKey = vapidPublicKey;

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey,
    });

    console.log("Nueva suscripción creada:", subscription);
    const suscirpcion = [subscription, Zona];
    console.log(suscirpcion);

    // 5️⃣ Enviar al backend para guardarla
    await fetch("https://www.bibliotecadlago.com/php/save-subscription.php", {
      method: "POST",
      body: JSON.stringify({
        Subscription: subscription,
        Zona: Zona,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  // Función para solicitar permiso de notificaciones push
  async function requestNotificationPermission() {
    const permission = await Notification.requestPermission();

    if (permission === "granted") {
      console.log("Permiso concedido");
      await subscribeUser();
    } else {
      console.log("Permiso denegado");
    }
  }

  // Función para manejar el cambio de filtro
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // Función para copiar al portapapeles
  const copiarAlPortapapeles = (texto) => {
    navigator.clipboard
      .writeText(texto)
      .then(() => {
        setAlerta({
          open: true,
          mensaje: "Copiado al portapapeles",
          tipo: "success",
        });
      })
      .catch((err) => {
        setAlerta({
          open: true,
          mensaje: "Error al copiar",
          tipo: "error",
        });
        console.error("Error al copiar al portapapeles: ", err);
      });
    console.log(PrecioHankook);
  };

  // Función abrir el modal de negar producto y configurar el producto a negar.
  const handleNegarProducto = (producto) => {
    setProductoANegar(producto);
    setCantidadNegada(1);
    setClienteProdNegado("");
    setModalNegarOpen(true);
  };

  // Función para abrir el modal de campaña emergente solo a clientes
  useEffect(() => {
    if (rol === "Cliente") {
      setModalCampanaEmergenteOpen(true);
    } else {
      setModalCampanaEmergenteOpen(false);
    }
  }, [rol]);

  // Función para cargar inventario y sucursales permitidas al cargar el componente y cada 10 minutos
  useEffect(() => {
    const cargarInventario = () => {
      let url = "https://bibliotecadlago.com/php/inventario.php";
      if (OtrasMarcas === 1 || OtrasMarcas === "1") {
        url = "https://bibliotecadlago.com/php/otramarcav2.php";
      }
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ idUsuario: parseInt(IdUsuario, 10) }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success && Array.isArray(data.data)) {
            const productosConId = data.data.map((item, index) => ({
              ...item,
              id: index + 1,
            }));
            setRows(productosConId);
            // Extraer marcas disponibles de los productos
            const marcasDisponibles = [
              ...new Set(productosConId.map((producto) => producto.marca)), // Usamos Set para eliminar duplicados
            ];
            setMarcasDisponibles(marcasDisponibles); // Guardamos las marcas disponibles
          } else {
            console.error("Respuesta inválida de la API");
          }
        })
        .catch((err) => {
          console.error("Error al obtener inventario:", err);
        });
    };

    const cargarSucursalesPermitidas = () => {
      if (!IdUsuario) return;

      fetch("https://bibliotecadlago.com/php/sucursales.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ idUsuario: parseInt(IdUsuario, 10) }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (Array.isArray(data.SucursalesPermitidas)) {
            setSucursalesPermitidas(data.SucursalesPermitidas);
          } else {
            console.error("No se pudieron obtener sucursales permitidas");
          }
        })
        .catch((err) => {
          console.error("Error al obtener sucursales permitidas:", err);
        });
    };

    const cargarVentas = () => {
      let url = "https://bibliotecadlago.com/php/ventas_asesor.php";
      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ idUsuario: parseInt(IdUsuario, 10) }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success && Array.isArray(data.data)) {
            setVentas(data.data);
          } else {
            console.error("Respuesta inválida de la API");
          }
        })
        .catch((err) => {
          console.error("Error al obtener las ventas:", err);
        });
    };

    cargarSucursalesPermitidas();
    cargarInventario();
    cargarVentas();

    const intervalo = setInterval(() => {
      cargarInventario();
    }, 600000); // 600000 ms = 10 minutos

    return () => clearInterval(intervalo);
  }, [OtrasMarcas, IdUsuario]);

  // Obtener el nombre de la sucursal seleccionada a partir del ID usando el mapa
  const sucursalSeleccionadaNombre = Object.entries(mapa_sucursales).find(
    ([nombre, id]) => id === Number(filters.sucursalId),
  )?.[0];

  // Función para confirmar la negación de producto, validando campos y enviando la información al backend
  const confirmarNegacion = async () => {
    if (
      !cantidadNegada ||
      cantidadNegada <= 0 ||
      !Number.isInteger(Number(cantidadNegada))
    ) {
      setAlerta({
        open: true,
        mensaje: "Ingresa una cantidad válida (entero positivo).",
        tipo: "warning",
      });
      return;
    }
    if (rol !== "Cliente" && !clienteProdNegado.trim()) {
      alert("Debes capturar el cliente que solicita las llantas");
      return;
    }
    var tipo;
    if (productoANegar.existencias > 0) {
      tipo = "No Disponible en Zona";
    } else {
      tipo = "Producto Negado";
    }
    try {
      const response = await fetch(
        "https://bibliotecadlago.com/php/negar_productov2.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            MSPN: productoANegar.MSPN,
            idUsuario: parseInt(IdUsuario, 10),
            cantidad: parseInt(cantidadNegada, 10),
            cliente: clienteProdNegado,
            Tipo: tipo,
            existencia: productoANegar.existencias,
          }),
        },
      );

      const data = await response.json();

      if (data.success) {
        setAlerta({
          open: true,
          mensaje: `Producto ${productoANegar.MSPN} negado con cantidad: ${cantidadNegada}`,
          tipo: "success",
        });
      } else {
        throw new Error(data.message || "Error al negar producto");
      }
    } catch (error) {
      console.error("Error al negar producto:", error);
      setAlerta({
        open: true,
        mensaje: "Hubo un error al marcar como negado.",
        tipo: "error",
      });
    }

    setModalNegarOpen(false);
  };

  // Función para filtrar los productos según los filtros aplicados y las campañas activas
  const filteredRows = rows.filter((row) => {
    // 1. Obtener los "Value" de las campañas que están encendidas en el switch
    // Esto crea un array como [1] o [1, 2]
    const valoresCampanasActivas = campanaActivas
      .filter((c) => switchesCampana[c.Nombre])
      .map((c) => c.Value);

    const existeEnSucursal =
      !filters.sucursalId ||
      (row.inventario_detalle &&
        row.inventario_detalle.some(
          (detalle) =>
            detalle.sucursal === sucursalSeleccionadaNombre &&
            detalle.cantidad > 0,
        ));

    // 2. Lógica de filtrado de campaña
    // Si no hay ningún switch activo, no filtramos por campaña (pasan todos)
    // Si hay switches activos, el row.campana debe estar incluido en los valores activos
    const cumpleCampanaDinamica =
      valoresCampanasActivas.length === 0 ||
      valoresCampanasActivas.includes(row.campana); // 'row.campana' es el nuevo campo en tu data

    return (
      (!filters.marca || row.marca === filters.marca) &&
      (!filters.ancho || row.ancho.toString() === filters.ancho) &&
      (!filters.alto || row.alto.toString() === filters.alto) &&
      (!filters.rin || row.rin.toString() === filters.rin) &&
      (!filters.MSPN ||
        row.MSPN.toLowerCase().includes(filters.MSPN.toLowerCase())) &&
      (!soloDisponibles || Number(row.existencias) > 0) &&
      (!invMichelin || codigosApiMichelin.includes(row?.MSPN?.toUpperCase())) &&
      cumpleCampanaDinamica && // <--- Nueva validación dinámica
      (!mto || row.mto === 1) &&
      (!filters.gama || row.gama === filters.gama) &&
      (!invNobhex || row.marca.toUpperCase() === "NOBHEX") &&
      (!liquidacionMichelin || (row.MSPN.toUpperCase() === "95011") || (row.MSPN.toUpperCase() === "83708") || (row.MSPN.toUpperCase() === "65230")|| (row.MSPN.toUpperCase() === "98415") || (row.MSPN.toUpperCase() === "01235") || (row.MSPN.toUpperCase() === "21974") || (row.MSPN.toUpperCase() === "44847") || (row.MSPN.toUpperCase() === "68386")) &&
      (!filtroBonificacion ||
        (row.rin >= 17 && row.marca?.toUpperCase() === "MICHELIN") ||
        (row.gama?.toString().toUpperCase().includes("TERRAIN") &&
          row.marca?.toUpperCase() === "BFGOODRICH")) &&
      existeEnSucursal
      // ... los demás filtros que ya tenías
    );
  });

  // Función para manejar la acción de agregar al carrito, mostrando una alerta de éxito
  const handleAgregarAlCarrito = (producto) => {
    agregarAlCarrito(producto);
    setAlerta({
      open: true,
      mensaje: `Agregado ${producto.descripcion} al carrito`,
      tipo: "success",
    });
  };

  // Definición de las columnas para el DataGrid, incluyendo renderizado personalizado para MSPN, descripción, precios y existencias, con lógica de colores y estilos según el estatus y campaña.
  const columns = useMemo(() => {
    return [
      {
        field: "MSPN",
        headerName: "MSPN",
        width: isMobile ? 80 : 80,
        renderCell: (params) => {
          const estatus = params.row.estatus;
          const campana = params.row.campana;
          const originalValue = params.value?.toString() || "";
          const halfLength = Math.floor(originalValue.length / 2);

          // Color por defecto
          let defaultColor = "#000";

          if (estatus === "ACTIVO") {
            defaultColor = "#242c59";
          } else if (estatus === "DESCONTINUADO") {
            defaultColor = "#ff6600";
          }

          // Si es campaña, colorear mitad en verde
          if (
            (VerCampanaExtras === 0 || VerCampanaExtras === "0") &&
            campana !== "0" &&
            dayjs(fechaActual).isBefore(
              dayjs(params.row.vigencia).add(1, "day"),
            )
          ) {
            const firstHalf = originalValue.slice(0, halfLength);
            const secondHalf = originalValue.slice(halfLength);

            return (
              <span style={{ fontWeight: "bold" }}>
                <span style={{ color: "#4caf50" }}>{firstHalf}</span>
                <span style={{ color: defaultColor }}>{secondHalf}</span>
              </span>
            );
          }

          // Si no es campaña, color único
          return (
            <span style={{ color: defaultColor, fontWeight: "bold" }}>
              {originalValue}
            </span>
          );
        },
      },
      {
        field: "descripcion",
        headerName: "Descripción",
        width: isMobile ? 475 : 475,
        renderCell: (params) => {
          const descripcion = params.row.descripcion;
          const mspn = params.row.MSPN;
          const precio = Number(params.row.precio).toLocaleString("es-MX", {
            style: "currency",
            currency: "MXN",
          });

          const textoACopiar = `MSPN: ${mspn}\n Descripción: ${descripcion}\nPrecio: ${precio}`;

          return (
            <Box display="flex" alignItems="center">
              <span style={{ marginRight: 8 }}>{descripcion}</span>
              <IconButton
                onClick={() => copiarAlPortapapeles(textoACopiar)}
                size="small"
                sx={{ color: "#9c27b0" }}
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Box>
          );
        },
      },

      !isMobile && { field: "ancho", headerName: "Ancho", width: 60 },
      !isMobile && { field: "alto", headerName: "Alto", width: 50 },
      !isMobile && { field: "rin", headerName: "Rin", width: 50 },
      {
        field: "Lista",
        headerName: "Precio Lista",
        width: isMobile ? 100 : 120,
        renderCell: (params) => {
          const valorNumerico = Number(params.value);
          return (
            <Box
              onClick={() => handleAbrirDetallesProducto(params.row)}
              sx={{
                cursor: "pointer",
                color: "#d32f2f",
                fontWeight: "bold",
              }}
            >
              $
              {valorNumerico.toLocaleString("es-MX", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Box>
          );
        },
      },
      {
        field: "Precios",
        headerName: "Precios",
        width: isMobile ? 70 : 70,
        renderCell: (params) => (
          <>
            <IconButton
              onClick={() => handleAbrirDetallesProducto(params.row)}
              sx={{ color: "#4caf50", ml: 1 }}
            >
              <PaidIcon />
            </IconButton>
          </>
        ),
      },
      {
        field: "existencias",
        headerName: "Existencias",
        width: isMobile ? 70 : 90,
        renderCell: (params) => {
          const detalle = params.row.inventario_detalle || [];

          let cantidad = 0;

          // Si hay sucursal seleccionada → mostrar solo esa
          if (filters.sucursalId) {
            cantidad =
              detalle.find(
                (item) => item.sucursal === sucursalSeleccionadaNombre,
              )?.cantidad || 0;
          }
          // Si NO hay sucursal seleccionada pero hay sucursalesPermitidas
          else if (sucursalesPermitidas.length > 0) {
            cantidad = detalle
              .filter((item) => sucursalesPermitidas.includes(item.sucursal))
              .reduce((acc, item) => acc + Number(item.cantidad || 0), 0);
          }
          // Si no tiene restricción → mostrar total normal
          else {
            cantidad = Number(params.row.existencias);
          }

          return (
            <>
              <Button
                sx={{
                  color: "#030166", // Color personalizado
                  fontSize: "18px",
                  "& .MuiSvgIcon-root": { fontSize: "18px" },
                }}
                onClick={() => handleAbrirModal(params.row)}
              >
                {cantidad}
              </Button>
            </>
          );
        },
      },
      {
        field: "agregar",
        headerName: "Pedir",
        width: isMobile ? 60 : 60,
        renderCell: (params) => (
          <>
            <IconButton
              onClick={() => handleAgregarAlCarrito(params.row)}
              sx={{ color: "#cf1316" }}
              disabled={
                params.row.existencias === 0 &&
                !codigosApiMichelin.includes(params.row?.MSPN?.toUpperCase())
              }
            >
              <ShoppingCartIcon />
            </IconButton>
          </>
        ),
      },
      {
        field: "Inventario",
        headerName: "Inventario Detallado",
        width: isMobile ? 150 : 150,
        renderCell: (params) => (
          <>
            <IconButton
              onClick={() => handleAbrirModal(params.row)}
              sx={{
                color: "#1976d2",
                padding: "6px", // Ajuste opcional para el tamaño del icono
              }}
            >
              <img
                src="verInv.png"
                alt="Icono Llantas"
                style={{
                  width: 35,
                  height: 35,
                }}
              />
            </IconButton>
            {ClaEnlaceMichelin !== "MAYOREO ABIERTO" &&
              codigosApiMichelin.includes(params.row?.MSPN?.toUpperCase()) && (
                <IconButton
                  onClick={() => handleAbrirModalExterno(params.row)}
                  sx={{
                    color: "#1976d2",
                    padding: "6px",
                  }}
                >
                  <img
                    src="camionMichelin.png"
                    alt="Icono Llantas"
                    style={{
                      width: 55,
                      height: 40,
                    }}
                  />
                </IconButton>
              )}
          </>
        ),
      },
      {
        field: "ProductoNegado",
        headerName: "Producto negado",
        width: isMobile ? 150 : 150,
        renderCell: (params) => (
          <>
            {params.row.estatus !== "DESCONTINUADO" && (
              <>
                <IconButton
                  onClick={() => handleNegarProducto(params.row)}
                  sx={{ color: "#ff1744", ml: 1 }}
                >
                  <Avatar
                    src="michelinpronegado.png"
                    variant="square"
                    sx={{
                      width: 45,
                      height: 45,
                    }}
                  />
                </IconButton>
              </>
            )}
          </>
        ),
      },
    ].filter(Boolean); // quita los campos falsos si es móvil
  }, [isMobile, agregarAlCarrito, handleNegarProducto]);

  // Función para abrir el modal de inventario detallado, cargar el detalle del inventario.
  const handleAbrirModal = async (producto) => {
    setProductoSeleccionado(producto);
    setDetalleInventario(producto.inventario_detalle || []);
    setInventarioExterno(null); // Limpiar datos previos
    setModalOpen(true);

    if (codigosApiMichelin.includes(producto.MSPN?.toUpperCase())) {
      setLoadingExterno(true);
      try {
        const response = await fetch(
          `https://bibliotecadlago.com/php/mi/michelin.php?mspn=${producto.MSPN}`,
        );
        const data = await response.json();
        setInventarioExterno(data);
      } catch (error) {
        console.error("Error consultando inventario externo:", error);
      } finally {
        setLoadingExterno(false);
      }
    }
  };

  // Función para abrir el modal de inventario detallado externo y consultar inventario externo si el producto es de la API Michelin.
  const handleAbrirModalExterno = async (producto) => {
    setProductoSeleccionado(producto);
    setDetalleInventario(producto.inventario_detalle || []);
    setInventarioExterno(null); // Limpiar datos previos
    setModalExternoOpen(true);

    if (codigosApiMichelin.includes(producto.MSPN?.toUpperCase())) {
      setLoadingExterno(true);
      try {
        const response = await fetch(
          `https://bibliotecadlago.com/php/mi/michelin.php?mspn=${producto.MSPN}`,
        );
        const data = await response.json();
        setInventarioExterno(data);
      } catch (error) {
        console.error("Error consultando inventario externo:", error);
      } finally {
        setLoadingExterno(false);
      }
    }
  };

  // Filtrar las sucursales a mostrar en el modal de inventario detallado según la configuración y las sucursales permitidas del usuario.
  const sucursalesAMostrar =
    VerSucursales === "0"
      ? Object.entries(mapa_sucursales).filter(([nombre, id]) =>
          sucursalesPermitidas.includes(nombre),
        )
      : Object.entries(mapa_sucursales);

  // Función para obtener las gamas disponibles según la marca seleccionada, actualizando el filtro de gama si la gama seleccionada ya no es válida.
  const gamasDisponibles = useMemo(() => {
    if (!filters.marca) {
      return [...new Set(rows.map((row) => row.gama).filter(Boolean))];
    }
    return [
      ...new Set(
        rows
          .filter((row) => row.marca === filters.marca)
          .map((row) => row.gama)
          .filter(Boolean),
      ),
    ];
  }, [filters.marca, rows]);

  // Si la gama seleccionada no es válida para la marca seleccionada, limpiar el filtro de gama
  useEffect(() => {
    if (filters.gama && !gamasDisponibles.includes(filters.gama)) {
      setFilters((prev) => ({ ...prev, gama: "" }));
    }
  }, [filters.marca, gamasDisponibles, filters.gama]);

  const mostrarPrecioHankook =
    productoPreciosLista?.marca?.toUpperCase() === "HANKOOK" && PrecioHankook;

  // Mapeo para el modal de precios
  const labelMap = {
    Lista: "Precio de Lista",
    VentaMayoreo: "Lista Venta Mayoreo",
    Mayoreo: "Precio Mayoreo",
    Especial1: "Especial 1",
    Especial2: "Especial 2",
    Especial3: "Especial 3",
    Especial4: "Especial 4",
    ColumnaA: "Columna A",
    ColumnaB: "Columna B",
    ColumnaC: "Columna C",
    PrecioBase: "Columna Precio Base",
    Mayoreo13a19: "Mayoreo 13-19 llantas",
    Mayoreo20mas: "Mayoreo 20 y mas",
    Mayoreo12Revendedores: "Mayoreo solo Revendedores 12+",
    Credito: "Precio de Crédito",
    MayoreoSoloRevendedores: "Mayoreo solo Revendedores",
  };

  // Si es Hankook con precio especial, mostrar solo Lista y PrecioHankook. Si no, mostrar todas las columnas disponibles según el labelMap.
  const filasPrecios = mostrarPrecioHankook
    ? [
        ["Lista", productoPreciosLista?.Lista],
        [PrecioHankook, productoPreciosLista?.[PrecioHankook]],
      ]
    : Object.keys(labelMap).map((key) => [key, productoPreciosLista?.[key]]);

  // Función para exportar a Excel, que obtiene los datos del backend, los acomoda para mostrar sucursales como columnas, y luego genera y descarga el archivo Excel.
  const exportToExcel = async () => {
    try {
      const response = await fetch(
        "https://bibliotecadlago.com/php/FormatoExcel.php",
      );
      const data = await response.json();
      if (data.success) {
        let inventarioExcel = data.data.map((item) => ({
          ...item,
          PrecioLista:
            item.PrecioLista === 0 ||
            item.PrecioLista === "" ||
            item.PrecioLista == null
              ? "No Disponible"
              : item.PrecioLista,
          mto:
            item.mto === 0 || item.mto === "" || item.mto == null
              ? ""
              : "Participa",
        }));

        if (VerSucursales === 0 || VerSucursales === "0") {
          console.log(sucursalesPermitidas);

          inventarioExcel = inventarioExcel.filter((inv) =>
            sucursalesPermitidas.includes(inv.sucursal),
          );
        }

        const pivot = {};

        inventarioExcel.forEach((item) => {
          const key = item.MSPN + "_" + item.descripcion;

          if (!pivot[key]) {
            pivot[key] = {
              MSPN: item.MSPN,
              descripcion: item.descripcion,
              PrecioLista: item.PrecioLista,
              estatus: item.estatus,
              mto: item.mto,
            };
          }

          pivot[key][item.sucursal] = item.Cantidad;
        });

        const resultado = Object.values(pivot);

        const worksheet = XLSX.utils.json_to_sheet(resultado);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "InventarioLago");
        XLSX.writeFile(workbook, "InventarioLago.xlsx");
      }
    } catch (error) {
      console.error("Error al recargar pedidos:", error);
    }
  };

  // Función específica para exportar el inventario de Michelin, que obtiene los datos del backend, acomoda las columnas para mostrar sucursales específicas y totales, y luego genera y descarga el archivo Excel.
  const exportToExcelInvMichelin = async () => {
    try {
      const url = "https://bibliotecadlago.com/php/mi/michelinTodo.php";

      const response = await fetch(url);
      if (!response.ok) throw new Error("Error en la respuesta del servidor");

      const datosPHP = await response.json();

      const resultadoFinal = datosPHP.map((item) => ({
        MSPN: item.mspn,
        Descripcion: item.descripcion || "Ver catálogo",
        "M05 Nuevo Leon": item.M05 || 0,
        "M21 Estado de Mexico": item.M21 || 0,
        Total: (item.M05 || 0) + (item.M21 || 0),
      }));

      const worksheet = XLSX.utils.json_to_sheet(resultadoFinal);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Inventario");

      worksheet["!cols"] = [
        { wch: 15 }, // MSPN
        { wch: 45 }, // Descripcion
        { wch: 10 }, // M05
        { wch: 10 }, // M21
        { wch: 10 }, // Total
      ];

      XLSX.writeFile(workbook, "Inventario_General.xlsx");
    } catch (error) {
      console.error("Error al procesar el Excel:", error);
      alert("No se pudo generar el reporte de inventario.");
    }
  };

  // Función para descargar el PDF de promoción de otras marcas, creando un enlace temporal y simulando un click para iniciar la descarga.
  const descargarPDF = () => {
    const pdfUrl = "/PromocionOtrasMarcas.pdf";

    // 2. Crear un elemento 'a' temporal
    const link = document.createElement("a");
    link.href = pdfUrl;

    // 3. Establecer el nombre con el que se guardará el archivo
    link.download = "PromocionOtrasMarcas.pdf";

    // 4. Añadir al documento, hacer click y remover
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Función para abrir el modal de detalles del producto, que unifica la consulta de datos de campaña, lista y mayoreo (MTO) en una sola función con manejo de errores y carga simultánea.
  const handleAbrirDetallesProducto = async (producto) => {
    // Limpieza
    setProductoCampana(null);
    setProductoPreciosLista(null);
    setProductoMayoreo(null);
    setProductoBonificacion(null);
    setGamaActual(producto.gama);
    setTabIndex(0);

    try {
      const fetchCampana = fetch(
        "https://bibliotecadlago.com/php/precioCampana.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ mspn: producto.MSPN }),
        },
      ).then((res) => res.json());

      const fetchLista = fetch(
        "https://bibliotecadlago.com/php/precioMayoreo.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ mspn: producto.MSPN }),
        },
      ).then((res) => res.json());

      // NUEVO fetch real de MTO
      const fetchMTO = fetch("https://bibliotecadlago.com/php/mto.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mspn: producto.MSPN }),
      }).then((res) => res.json());

      const [resCampana, resLista, resMTO] = await Promise.all([
        fetchCampana,
        fetchLista,
        fetchMTO,
      ]);

      // Campaña
      if (resCampana.success && resCampana.data?.length > 0) {
        setProductoCampana(resCampana.data[0]);
      }

      // Lista
      if (resLista.success && resLista.data?.length > 0) {
        const data = resLista.data[0];
        setProductoPreciosLista(data);
      }
      // MTO SOLO si hay datos
      if (
        resMTO.success &&
        Array.isArray(resMTO.data) &&
        resMTO.data.length > 0
      ) {
        setProductoMayoreo(resMTO.data[0]);
        setCampana50Asociados(false); // Desactivar campaña 50 asociados si hay datos de MTO
        setCampanaBonificacionAsociados(false); // Desactivar campaña de bonificación asociados si hay datos de MTO
        setProductoBonificacion(null);
      } else {
        if (
          producto.marca?.toUpperCase() === "MICHELIN" ||
          (producto.marca?.toUpperCase() === "BFGOODRICH" &&
            producto.gama?.toUpperCase().includes("TERRAIN"))
        ) {
          console.log(producto.gama);
          setCampana50Asociados(true);
        } else {
          setCampana50Asociados(false);
        }
        if (
          (producto.marca?.toUpperCase() === "MICHELIN" && producto.rin > 16) ||
          (producto.marca?.toUpperCase() === "BFGOODRICH" &&
            producto.gama?.toUpperCase().includes("TERRAIN")) ||
          producto.mspn?.toUpperCase() === "11610" ||
          producto.mspn?.toUpperCase() === "07251" ||
          producto.mspn?.toUpperCase() === "23891" ||
          producto.mspn?.toUpperCase() === "08247" ||
          producto.mspn?.toUpperCase() === "16840" ||
          producto.mspn?.toUpperCase() === "60932" ||
          producto.mspn?.toUpperCase() === "21891" ||
          producto.mspn?.toUpperCase() === "21818" ||
          producto.mspn?.toUpperCase() === "79813" ||
          producto.mspn?.toUpperCase() === "42495"
        ) {
          setCampanaBonificacionAsociados(true);
          setProductosBonificacion(producto);
          console.log(productosBonificacion);
        } else {
          setCampanaBonificacionAsociados(false);
          setProductoANegar(null);
        }
      }

      setModalDetalleOpen(true);
    } catch (error) {
      console.error("Error al unificar datos:", error);

      setAlerta({
        open: true,
        mensaje: "Error al consultar la información del producto.",
        tipo: "error",
      });
    }
  };

  // Configuración de las pestañas a mostrar en el modal de detalles del producto, que se muestra u oculta según la disponibilidad de datos para campaña, lista y mayoreo.
  const tabsDisponibles = [
    {
      label: "Campaña",
      show:
        productoCampana !== null &&
        dayjs(fechaActual).isBefore(dayjs(productoCampana.fin).add(1, "day")) &&
        dayjs(fechaActual).isAfter(
          dayjs(productoCampana.inicio).subtract(1, "day"),
        ),
      content: (
        <Box sx={{ p: 1 }}>
          <Typography component="div" variant="subtitle1" gutterBottom>
            🏷️ {productoCampana?.nombre}
          </Typography>

          <p>
            <strong>Descripción:</strong> {productoCampana?.descripcion}
          </p>

          <p>
            <strong>MSPN:</strong> {productoCampana?.MSPN}
          </p>

          <p>
            <strong>Vigencia:</strong> Del{" "}
            {productoCampana?.inicio
              ? new Date(
                  productoCampana.inicio + "T12:00:00",
                ).toLocaleDateString("es-ES")
              : "No especificada"}{" "}
            al{" "}
            {productoCampana?.fin
              ? new Date(productoCampana.fin + "T12:00:00").toLocaleDateString(
                  "es-ES",
                )
              : "No especificada"}
          </p>

          <Typography variant="body1" component="span">
            {productoCampana?.porcentaje > 0 ? (
              <strong>
                Porcentaje de descuento adicional:{" "}
                <Typography component="span" fontSize={45}>
                  {" "}
                  {productoCampana.porcentaje}%{" "}
                </Typography>
              </strong>
            ) : (
              <strong>
                Precio Promocion{" "}
                {productoCampana?.nota?.toLowerCase().includes("neto")
                  ? ""
                  : "+ IVA"}
                : ${productoCampana?.precio || " No especificado"}
              </strong>
            )}
          </Typography>

          <p>
            <strong>Nota:</strong> {productoCampana?.nota}
          </p>
        </Box>
      ),
    },
    {
      label: "Campaña 50 Asociados",
      show:
        campana50Asociados &&
        dayjs(fechaActual).isBefore("2026-09-30") &&
        dayjs(fechaActual).isAfter("2026-09-01") &&
        (ClaEnlaceMichelin === "ORO" ||
          ClaEnlaceMichelin === "BIB+" ||
          ClaEnlaceMichelin === "PLATA" ||
          rol !== "Cliente"),
      content: (
        <Box sx={{ p: 1 }}>
          <p>
            <strong>Vigencia:</strong> Del 01 al 30 Septiembre 2026
          </p>
          <p>
            <strong>Canal participante:</strong> Clientes indirectos BIB+, ORO,
            PLATA
          </p>
          <p>
            <strong>Rines participantes:</strong> MICHELIN Y BFGOODRICH ROR (All
            Terrain, Mud Terrain, HD Terrain, Trail Terrain), (NO APLICA
            BFGOODRICH MTO).
          </p>
          <Box
            component="img"
            src="/tablaasocampana.png"
            alt="Publicidad"
            sx={{
              width: "80%",
              height: "auto",
              display: "block",
              borderRadius: 2,
            }}
          />
          <Typography
            component="div"
            variant="caption"
            display="block"
          ></Typography>
        </Box>
      ),
    },
    {
      label: "Campaña de Sell In Asociados",
      show:
        campanaBonificacionAsociados &&
        dayjs(fechaActual).isBefore("2026-09-23") &&
        dayjs(fechaActual).isAfter("2026-08-24") &&
        (ClaEnlaceMichelin === "ORO" ||
          ClaEnlaceMichelin === "BIB+" ||
          ClaEnlaceMichelin === "PLATA" ||
          rol !== "Cliente"),
      content: (
        <Box sx={{ p: 1 }}>
          <p>
            <strong>Vigencia:</strong> Del 24 Agosto al 23 Septiembre 2026
          </p>
          <p>
            <strong>Canal participante:</strong> Clientes indirectos BIB+, ORO,
            PLATA
          </p>
          <p>
            <strong>Rines participantes:</strong> MICHELIN 17 + Y BFGOODRICH ROR
            (All Terrain, Mud Terrain, HD Terrain, Trail Terrain), (NO APLICA
            BFGOODRICH MTO).
          </p>
          <Typography variant="body1" component="span">
            <strong>
              Porcentaje de descuento adicional en Factura:{" "}
              <Typography component="span" fontSize={25}>
                {productosBonificacion?.marca === "MICHELIN" ? "5%" : "4%"}
              </Typography>
            </strong>
          </Typography>
          <br />
          {[
            "20375",
            "50153",
            "56770",
            "17276",
            "72961",
            "14038",
            "54082",
            "49635",
            "67326",
            "79406",
            "03101",
            "39974",
            "62015",
            "00715",
            "52571",
            "40204",
            "95554",
            "13647",
            "38984",
          ].includes(productosBonificacion?.MSPN) && (
            <Typography variant="body1" component="span">
              <strong>
                Porcentaje de descuento adicional en Nota de credito:{" "}
                <Typography component="span" fontSize={25}>
                  {productosBonificacion?.marca === "MICHELIN" ? "2%" : "3%"}
                </Typography>
              </strong>
            </Typography>
          )}
        </Box>
      ),
    },
    {
      label: "Precios ADVANTAGE T/A BFGOODRICH y UNIRROYAL",
      show: productoMayoreo !== null,
      content: (
        <Box sx={{ p: 1 }}>
          <p>
            <strong>Descripción:</strong> {productoMayoreo?.descripcion}
          </p>

          <p style={{ color: "gray" }}>
            Todos los precios mostrados son antes de IVA
          </p>

          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>1 - 40 Llantas</strong>
                </TableCell>

                <TableCell>
                  <strong>41 - 80 Llantas</strong>
                </TableCell>

                <TableCell>
                  <strong>81 + Llantas</strong>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              <TableRow>
                <TableCell>
                  {productoMayoreo?.May1_40
                    ? `$${Number(productoMayoreo.May1_40).toLocaleString(
                        "es-MX",
                      )}`
                    : "-"}
                </TableCell>

                <TableCell>
                  {productoMayoreo?.May41_80
                    ? `$${Number(productoMayoreo.May41_80).toLocaleString(
                        "es-MX",
                      )}`
                    : "-"}
                </TableCell>

                <TableCell>
                  {productoMayoreo?.May81
                    ? `$${Number(productoMayoreo.May81).toLocaleString(
                        "es-MX",
                      )}`
                    : "-"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Typography component="div" variant="caption" display="block">
            Nota: SI aplica 3% Pronto Pago (PP).
          </Typography>
        </Box>
      ),
    },
    {
      label: "Precios",
      show: productoPreciosLista !== null,
      content: (
        <Box
          sx={{
            display: "flex",
            gap: "24px",
            flexDirection: { xs: "column", md: "row" },
            p: 1,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography component="div" variant="subtitle2">
              Descripción: {productoPreciosLista?.descripcion}
            </Typography>

            <p
              style={{
                fontSize: "0.85rem",
                color: "gray",
              }}
            >
              Precios antes de IVA
            </p>

            <Table size="small">
              <TableBody>
                {filasPrecios
                  .filter(([key, value]) => {
                    // Validación 1: El valor debe ser mayor a 0
                    const esMayorAZero = Number(value) > 0;

                    // Validación 2: Si es Especial4, verificar que el usuario tenga el rol permitido
                    if (key === "Especial4") {
                      return esMayorAZero && tienePermisoEspecial4;
                    }

                    return esMayorAZero;
                  })
                  .map(([key, value], idx) => (
                    <TableRow key={idx}>
                      <TableCell>
                        <strong>{labelMap[key] || key}</strong>
                      </TableCell>

                      <TableCell align="right">
                        {`$${Number(value).toLocaleString("es-MX", {
                          minimumFractionDigits: 2,
                        })}`}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>

            {(productoPreciosLista?.marca === "HANKOOK" ||
              productoPreciosLista?.marca === "NOBHEX") && (
              <p
                style={{
                  marginTop: 10,
                  fontSize: "0.8rem",
                }}
              >
                <strong>Nota:</strong> SI aplica 3% Pronto Pago (PP).
              </p>
            )}
          </Box>

          {imagenEncontrada && (
            <Box
              sx={{
                flex: { md: "0 0 300px" },
                textAlign: "center",
              }}
            >
              <img
                src={imagenEncontrada.url}
                alt="Producto"
                style={{
                  width: "100%",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                }}
              />
            </Box>
          )}
        </Box>
      ),
    },
  ].filter((tab) => tab.show);

  // Definición de la prioridad de marcas para el ordenamiento, donde las marcas listadas tienen una prioridad numérica y las no listadas se ordenan alfabéticamente después de las listadas.
  const brandPriority = {
    MICHELIN: 1,
    BFGOODRICH: 2,
    UNIROYAL: 3,
    HANKOOK: 4,
    LAUFENN: 5,
    NOBHEX: 6,
    BLACKHAWK: 7,
    SURETRAC: 8,
    MIRAGE: 9,
  };

  // Función para ordenar los productos filtrados según la prioridad de marca, luego por gama alfabéticamente, y finalmente por rin de mayor a menor.
  const sortedRows = [...filteredRows].sort((a, b) => {
    const pA = brandPriority[a.marca];
    const pB = brandPriority[b.marca];

    // Caso 1: Ambas marcas están en la lista de prioridad
    if (pA !== undefined && pB !== undefined) {
      if (pA !== pB) return pA - pB;
    }
    // Caso 2: Solo la marca A está en la lista (va primero)
    else if (pA !== undefined) {
      return -1;
    }
    // Caso 3: Solo la marca B está en la lista (va primero)
    else if (pB !== undefined) {
      return 1;
    }
    // Caso 4: Ninguna está en la lista (Orden Alfabético A-Z entre ellas)
    else {
      if (a.marca < b.marca) return -1;
      if (a.marca > b.marca) return 1;
    }

    // --- Segundo Nivel: Gama (A-Z) ---
    if (a.gama < b.gama) return -1;
    if (a.gama > b.gama) return 1;

    // --- Tercer Nivel: Rin (Mayor a Menor) ---
    return b.rin - a.rin;
  });

  return (
    <>
      {/* Navbar y carousel de banners */}
      <Navbar />
      <CustomCarousel images={banners} />
      <Box p={2}>
        <h2>Filtros</h2>
        <Box
          display="flex"
          flexDirection={{ xs: "column", md: "row" }}
          gap={3}
          mb={2}
          sx={{
            width: "100%",
          }}
        >
          <Box
            sx={{
              width: {
                xs: "100%",
                md: "65%",
              },
            }}
          >
            {/* MARCA + GAMA */}
            <Box
              display="flex"
              flexDirection={{ xs: "column", sm: "row" }}
              alignItems={{ xs: "flex-start", sm: "center" }}
              gap={2}
              mb={2}
            >
              <FormControl
                sx={{
                  width: {
                    xs: "80%",
                    sm: "45%",
                  },
                }}
              >
                <InputLabel>Marca</InputLabel>

                <Select
                  name="marca"
                  value={filters.marca}
                  onChange={handleFilterChange}
                  label="Marca"
                >
                  <MenuItem value="">Todas</MenuItem>

                  <MenuItem value="MICHELIN">MICHELIN</MenuItem>

                  <MenuItem value="BFGOODRICH">BFGOODRICH</MenuItem>

                  <MenuItem value="UNIROYAL">UNIROYAL</MenuItem>

                  {OtrasMarcas === "1" && (
                    <MenuItem value="HANKOOK">HANKOOK</MenuItem>
                  )}

                  {OtrasMarcas === "1" && (
                    <MenuItem value="LAUFENN">LAUFENN</MenuItem>
                  )}

                  {OtrasMarcas === "1" && (
                    <MenuItem value="NOBHEX">NOBHEX</MenuItem>
                  )}

                  {OtrasMarcas === "1" && (
                    <MenuItem value="BLACKHAWK">BLACKHAWK</MenuItem>
                  )}

                  {OtrasMarcas === "1" && (
                    <MenuItem value="SURETRAC">SURETRAC</MenuItem>
                  )}

                  {OtrasMarcas === "1" && (
                    <MenuItem value="GREEN MAX">GREEN MAX</MenuItem>
                  )}
                </Select>
              </FormControl>

              <FormControl
                sx={{
                  width: {
                    xs: "80%",
                    sm: "45%",
                  },
                }}
              >
                <InputLabel>Gama</InputLabel>

                <Select
                  name="gama"
                  value={filters.gama}
                  onChange={handleFilterChange}
                  label="Gama"
                >
                  <MenuItem value="">Todas</MenuItem>

                  {gamasDisponibles.map((gama, index) => (
                    <MenuItem key={index} value={gama}>
                      {gama}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <Box display="flex" gap={2} flexWrap="wrap" mb={2}>
              <TextField
                label="Ancho"
                name="ancho"
                value={filters.ancho}
                onChange={handleFilterChange}
              />

              <TextField
                label="Alto"
                name="alto"
                value={filters.alto}
                onChange={handleFilterChange}
              />

              <TextField
                label="Rin"
                name="rin"
                value={filters.rin}
                onChange={handleFilterChange}
              />
            </Box>

            {/* MSPN */}
            <Box
              display="flex"
              alignItems="center"
              flexWrap="wrap"
              gap={2}
              mb={2}
            >
              <TextField
                label="MSPN"
                name="MSPN"
                value={filters.MSPN}
                onChange={handleFilterChange}
                sx={{
                  mb: 3,
                }}
              />
            </Box>
          </Box>
          <Box
            sx={{
              width: {
                xs: "100%",
                md: "45%",
              },
              display: "flex",
              flexDirection: {
                xs: "column",
                md: "row",
              },
              alignItems: "center",
              justifyContent: {
                xs: "flex-start",
                md: "center",
              },
              gap: {
                xs: 2,
                md: 1,
              },
              minHeight: {
                xs: "auto",
                md: 220,
              },
              overflow: "hidden",
            }}
          >
            {ventas?.length > 0 && (
              <TableContainer
                sx={{
                  width: "auto",
                  maxWidth: {
                    xs: "150%",
                    md: 400,
                  },
                  overflow: "hidden",
                  flexShrink: 1,
                }}
              >
                <Table
                  size="small"
                  sx={{
                    width: "100%",
                    "& .MuiTableCell-root": {
                      padding: {
                        xs: "4px 5px",
                        md: "5px 8px",
                      },
                      fontSize: {
                        xs: "17px",
                        md: "17px",
                      },
                      lineHeight: 1.2,
                      whiteSpace: "nowrap",
                    },
                    "& .MuiTableHead-root .MuiTableCell-root": {
                      fontWeight: "bold",
                      fontSize: {
                        xs: "17px",
                        md: "17px",
                      },
                    },
                    "& .MuiTableBody-root .MuiTableRow-root": {
                      height: {
                        xs: "20px",
                        md: "24px",
                      },
                    },
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Marca</TableCell>
                      <TableCell align="right">Actual</TableCell>
                      <TableCell align="right">Meta</TableCell>
                      <TableCell align="right">Falt.</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {ventas.map((venta, index) => {
                      const actual = Number(venta.Actual) || 0;
                      const meta = Number(venta.Meta) || 0;
                      const faltante = Math.max(meta - actual, 0);
                      return (
                        <TableRow key={index}>
                          <TableCell>{venta.Marca}</TableCell>
                          <TableCell align="right">{actual}</TableCell>
                          <TableCell align="right">{meta}</TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              color:
                                faltante > 0 ? "error.main" : "success.main",
                              fontWeight: "bold",
                            }}
                          >
                            {faltante}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            {rutaTarjeta && rol === "Cliente" && (
              <Box
                component="img"
                src={rutaTarjeta}
                alt="Logo"
                sx={{
                  height: {
                    xs: ventas?.length > 0 ? 145 : 200,
                  },

                  width: "auto",

                  maxWidth: {
                    xs: "80%",
                    md: "80%",
                  },

                  objectFit: "contain",

                  flexShrink: 1,
                }}
              />
            )}
          </Box>
        </Box>

        <Box
          display="grid"
          gridTemplateColumns={{
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
          }}
          gap={2}
          backgroundColor="#004f9f"
          p={2}
          borderRadius={2}
          mb={2}
          alignItems="center"
        >
          {/* SOLO DISPONIBLES */}
          <FormControlLabel
            control={
              <Switch
                checked={soloDisponibles}
                onChange={(e) => setSoloDisponibles(e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#d32f2f",

                    "&:hover": {
                      backgroundColor: "rgba(211, 47, 47, 0.08)",
                    },
                  },

                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#d32f2f",
                  },
                }}
              />
            }
            label={
              <Typography
                fontWeight="bold"
                sx={{
                  color: "white",
                }}
              >
                SOLO DISPONIBLES
              </Typography>
            }
            sx={{
              ml: 2,
            }}
          />

          <FormControlLabel
            control={
              <Switch
                checked={invMichelin}
                onChange={(e) => setInvMichelin(e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#d32f2f",

                    "&:hover": {
                      backgroundColor: "rgba(211, 47, 47, 0.08)",
                    },
                  },

                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#d32f2f",
                  },
                }}
              />
            }
            label={
              <Typography
                fontWeight="bold"
                sx={{
                  color: "white",
                }}
              >
                INVENTARIO MICHELIN
              </Typography>
            }
            sx={{
              ml: 2,
            }}
          />

          <FormControlLabel
            control={
              <Switch
                checked={mto}
                onChange={(e) => setMto(e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#d32f2f",

                    "&:hover": {
                      backgroundColor: "rgba(211, 47, 47, 0.08)",
                    },
                  },

                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#d32f2f",
                  },
                }}
              />
            }
            label={
              <Typography
                fontWeight="bold"
                sx={{
                  color: "white",
                }}
              >
                ADVANTAGE T/A BFGOODRICH Y UNIRROYAL
              </Typography>
            }
            sx={{
              ml: 2,
            }}
          />

          {campanaActivas.map((campana, index) => {
            const esValida = dayjs(fechaActual).isBefore(
              dayjs(campana.Fin).add(1, "day"),
            );

            if (
              esValida &&
              dayjs(fechaActual).isAfter(
                dayjs(campana.Inicio).subtract(1, "day"),
              ) &&
              (VerCampanaExtras === 0 || VerCampanaExtras === "0")
            ) {
              return (
                <FormControlLabel
                  key={index}
                  control={
                    <Switch
                      checked={!!switchesCampana[campana.Nombre]}
                      onChange={handleSwitchChange(campana.Nombre)}
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: "#d32f2f",

                          "&:hover": {
                            backgroundColor: "rgba(211, 47, 47, 0.08)",
                          },
                        },

                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: "#d32f2f",
                          },
                      }}
                    />
                  }
                  label={
                    <Typography
                      fontWeight="bold"
                      sx={{
                        color: "white",
                      }}
                    >
                      CAMPAÑA {campana.Nombre}
                    </Typography>
                  }
                  sx={{
                    ml: 2,
                  }}
                />
              );
            }

            return null;
          })}

          {OtrasMarcas !== "0" && (
            <FormControlLabel
              control={
                <Switch
                  checked={invNobhex}
                  onChange={(e) => setInvNobhex(e.target.checked)}
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "#d32f2f",

                      "&:hover": {
                        backgroundColor: "rgba(211, 47, 47, 0.08)",
                      },
                    },

                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#d32f2f",
                    },
                  }}
                />
              }
              label={
                <Typography
                  fontWeight="bold"
                  sx={{
                    color: "white",
                  }}
                >
                  NOBHEX
                </Typography>
              }
              sx={{
                ml: 2,
              }}
            />
          )}
          <FormControlLabel
            control={
              <Switch
                checked={liquidacionMichelin}
                onChange={(e) => setLiquidacionMichelin(e.target.checked)}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": {
                    color: "#d32f2f",

                    "&:hover": {
                      backgroundColor: "rgba(211, 47, 47, 0.08)",
                    },
                  },

                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#d32f2f",
                  },
                }}
              />
            }
            label={
              <Typography
                fontWeight="bold"
                sx={{
                  color: "white",
                }}
              >
                LIQUIDACIÓN MICHELIN
              </Typography>
            }
            sx={{
              ml: 2,
            }}
          />
        </Box>
        {!isMobile && (
          <Box sx={{ ml: 2 }}>
            <p
              style={{
                fontSize: "14px",
                color: "#555",
                fontStyle: "italic",
                margin: 0,
              }}
            >
              Todos los precios mostrados son antes de IVA
            </p>
          </Box>
        )}

        <FormControl
          sx={{
            width: "80%",
            mb: 2,
          }}
        >
          <InputLabel>Sucursal</InputLabel>

          <Select
            name="sucursalId"
            value={filters.sucursalId}
            onChange={handleFilterChange}
            label="Sucursal"
          >
            <MenuItem value="">Todas</MenuItem>

            {sucursalesAMostrar.map(([nombre, id]) => (
              <MenuItem key={id} value={id}>
                {nombre}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box
          display="flex"
          alignItems="center"
          gap={2}
          mb={2}
          mt={1}
          flexWrap="wrap"
        >
          <Box display="flex" alignItems="center" gap={1}>
            <Box
              sx={{
                width: 20,
                height: 20,
                backgroundColor: "#242c59",
                borderRadius: "4px",
              }}
            />

            <span>Activo</span>
          </Box>

          <Box display="flex" alignItems="center" gap={1}>
            <Box
              sx={{
                width: 20,
                height: 20,
                backgroundColor: "#ff6600",
                borderRadius: "4px",
              }}
            />

            <span>Fuera de gama</span>
          </Box>

          {(VerCampanaExtras === 0 || VerCampanaExtras === "0") && (
            <Box display="flex" alignItems="center" gap={1}>
              <Box
                sx={{
                  width: 20,
                  height: 20,
                  backgroundColor: "#4caf50",
                  borderRadius: "4px",
                }}
              />

              <span>Campaña</span>
            </Box>
          )}

          <Box display="flex" alignItems="center" gap={1}>
            <PaidIcon
              sx={{
                color: "#4caf50",
                ml: 1,
              }}
            />

            <span>Precios</span>
          </Box>

          {(rol !== "Cliente" ||
            ClaEnlaceMichelin === "BIB+" ||
            ClaEnlaceMichelin === "ORO" ||
            Telefono === "Descargar") && (
            <Button
              variant="contained"
              color="primary"
              onClick={exportToExcel}
              sx={{
                backgroundColor: "#242c59",
                color: "#fff",

                "&:hover": {
                  backgroundColor: "#1b2247",
                },

                mb: 2,
              }}
            >
              <DownloadIcon />
            </Button>
          )}

          {(OtrasMarcas === 1 || OtrasMarcas === "1") && (
            <Button
              variant="contained"
              color="primary"
              onClick={descargarPDF}
              sx={{
                backgroundColor: "#a81f1f",
                color: "#fff",

                "&:hover": {
                  backgroundColor: "#a81f1f",
                },

                mb: 2,
              }}
            >
              <DownloadIcon />
              PDF Campaña Especial Multimarca
            </Button>
          )}

          {rol !== "Cliente" && (
            <Button
              variant="contained"
              color="primary"
              onClick={exportToExcelInvMichelin}
              sx={{
                backgroundColor: "#242c59",
                color: "#fff",

                "&:hover": {
                  backgroundColor: "#1b2247",
                },

                mb: 2,
              }}
            >
              <DownloadIcon />
              Inventario Michelin
            </Button>
          )}
        </Box>

        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <BlockIcon
            sx={{
              color: "#ff1744",
            }}
          />

          <span
            style={{
              fontSize: "14px",
            }}
          >
            Si no hay existencia, marcalo como <strong>negado</strong> para
            solicitar más.
          </span>

          {rol !== "Cliente" && (
            <Button
              variant="contained"
              size="small"
              onClick={requestNotificationPermission}
              sx={{
                ml: "auto",
                textTransform: "none",
              }}
            >
              Activar notificaciones
            </Button>
          )}
        </Box>

        <Box display="flex" alignItems="center" gap={1} mb={2}>
          {isMobile && (
            <p
              style={{
                fontSize: "16px",
                color: "#555",
                fontStyle: "italic",
              }}
            >
              Todos los precios mostrados son antes de IVA
            </p>
          )}
        </Box>

        <DataGrid
          rows={sortedRows}
          columns={columns}
          autoHeight
          pageSize={5}
          rowsPerPageOptions={[5, 10]}
        />
      </Box>

      {/* Componente de alerta para mostrar mensajes de éxito o error al usuario, con autoocultación después de 1 segundo. */}
      <Snackbar
        open={alerta.open}
        autoHideDuration={1000}
        onClose={() => setAlerta({ ...alerta, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setAlerta({ ...alerta, open: false })}
          severity={alerta.tipo}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alerta.mensaje}
        </Alert>
      </Snackbar>

      {/* Modal de inventario detallado por sucursal muestra la disponibilidad local */}
      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          Inventario por sucursal - {productoSeleccionado?.MSPN}
        </DialogTitle>
        <DialogContent>
          {/* TABLA DE INVENTARIO LOCAL (Tus sucursales normales) */}
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <b>Sucursal</b>
                </TableCell>
                <TableCell>
                  <b>Cantidad</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {detalleInventario
                .filter(
                  (item) =>
                    Number(item.cantidad) > 0 &&
                    (!filters.sucursalId ||
                      item.sucursal === sucursalSeleccionadaNombre) &&
                    (sucursalesPermitidas.length === 0 ||
                      sucursalesPermitidas.includes(item.sucursal)),
                )
                .map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.sucursal}</TableCell>
                    <TableCell>{item.cantidad}</TableCell>
                  </TableRow>
                ))}

              {/* Mensaje de otras sucursales */}
              {VerSucursales === "0" &&
                detalleInventario.some(
                  (item) =>
                    Number(item.cantidad) > 0 &&
                    !sucursalesPermitidas.includes(item.sucursal),
                ) && (
                  <TableRow>
                    <TableCell
                      colSpan={2}
                      style={{
                        color: "#888",
                        fontStyle: "italic",
                        fontSize: "0.85rem",
                      }}
                    >
                      Existen unidades en otras sucursales consultar con el
                      asesor asignado.
                    </TableCell>
                  </TableRow>
                )}
            </TableBody>
          </Table>
        </DialogContent>
      </Dialog>

      {/* Modal de inventario detallado por bodegas externas muestra la disponibilidad en bodegas Michelin. */}
      <Dialog
        open={modalExternoOpen}
        onClose={() => setModalExternoOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          Inventario por sucursal - {productoSeleccionado?.MSPN}
        </DialogTitle>
        <DialogContent>
          {/* SECCIÓN SEPARADA: INVENTARIO BODEGAS EXTERNAS */}
          {codigosApiMichelin.includes(
            productoSeleccionado?.MSPN?.toUpperCase(),
          ) && (
            <div
              style={{
                marginTop: "5px",
                paddingTop: "5px",
              }}
            >
              <Typography
                variant="subtitle2"
                style={{
                  color: "#1976d2",
                  marginBottom: "10px",
                  fontWeight: "bold",
                }}
              >
                DISPONIBILIDAD EN MICHELIN
              </Typography>

              {loadingExterno ? (
                <Typography variant="body2" style={{ fontStyle: "italic" }}>
                  Consultando a planta...
                </Typography>
              ) : (
                <Table size="small" style={{ backgroundColor: "#f5faff" }}>
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        <b>Bodega M05 (Nuevo Leon)</b>
                      </TableCell>
                      <TableCell align="right">
                        {inventarioExterno?.M05 || 0}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>
                        <b>Bodega M21 (Estado de México)</b>
                      </TableCell>
                      <TableCell align="right">
                        {inventarioExterno?.M21 || 0}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Modal de detalles del producto, que unifica la información de campaña, precios de lista y mayoreo en pestañas, y permite agregar al carrito si el producto tiene existencias. */}
      <Dialog
        open={modalDetalleOpen}
        onClose={() => setModalDetalleOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            pb: 0,
          }}
        >
          <Typography component="div" variant="h6" sx={{ mb: 1 }}>
            Detalles del Producto -{" "}
            {productoPreciosLista?.MSPN ||
              productoCampana?.MSPN ||
              "Cargando..."}
            <IconButton
              onClick={() => handleAgregarAlCarrito(productoPreciosLista)}
              sx={{ color: "#cf1316" }}
              disabled={productoPreciosLista?.existencias === 0}
            >
              <ShoppingCartIcon />
              Agregar al carrito
            </IconButton>
          </Typography>
          <Tabs
            value={tabIndex}
            onChange={(e, val) => setTabIndex(val)}
            variant="scrollable"
            scrollButtons="auto"
          >
            {tabsDisponibles.map((tab, idx) => (
              <Tab key={idx} label={tab.label} />
            ))}
          </Tabs>
        </DialogTitle>

        <DialogContent dividers>
          {tabsDisponibles.length > 0 ? (
            tabsDisponibles[tabIndex]?.content
          ) : (
            <Box sx={{ p: 3, textAlign: "center" }}>
              <Typography color="textSecondary">
                Consultando precios disponibles...
              </Typography>
            </Box>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setModalDetalleOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal para reportar producto no encontrado, que permite ingresar el cliente solicitante y la cantidad no encontrada, y luego reportar esta información para su seguimiento. */}
      <Dialog
        open={modalNegarOpen}
        onClose={() => setModalNegarOpen(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Avatar
            src="michelinpronegado.png"
            variant="circular"
            sx={{
              width: 50,
              height: 50,
            }}
          />
          <span>Producto no encontrado</span>
        </DialogTitle>
        <DialogContent>
          <p>
            <strong>MSPN:</strong> {productoANegar?.MSPN}
          </p>
          <p>
            <strong>Descripción:</strong> {productoANegar?.descripcion}
          </p>
          <p>
            <strong>Existencias:</strong> {productoANegar?.existencias}
          </p>
          {rol !== "Cliente" && (
            <TextField
              id="clienteProdNegado"
              label="Cliente que solicita las llantas"
              fullWidth
              required
              error={!clienteProdNegado}
              helperText={!clienteProdNegado ? "Este campo es obligatorio" : ""}
              value={clienteProdNegado}
              onChange={(e) => {
                setClienteProdNegado(e.target.value);
              }}
              sx={{ mt: 2 }}
            />
          )}
          <TextField
            id="cantidadNoEncontrada"
            label="Cantidad no encontrada"
            type="number"
            fullWidth
            inputProps={{ min: 1, step: 1 }}
            value={cantidadNegada}
            onChange={(e) => {
              const val = e.target.value;
              if (/^\d*$/.test(val)) {
                setCantidadNegada(val);
              }
            }}
            sx={{ mt: 2 }}
          />
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <IconButton
              onClick={confirmarNegacion}
              color="error"
              variant="contained"
              sx={{ px: 2 }}
            >
              <Avatar
                src="michelinpronegado.png"
                variant="circular"
                sx={{
                  width: 45,
                  height: 45,
                }}
              />
              <span style={{ marginLeft: 8 }}>Reportar</span>
            </IconButton>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Modal de campaña emergente, que muestra una imagen promocional y un botón para cerrarla, diseñado para llamar la atención del usuario sobre promociones especiales. */}
      <Dialog
        open={modalCampanaEmergenteOpen}
        onClose={() => setModalCampanaEmergenteOpen(false)}
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            position: "relative",
            overflow: "visible",
          },
        }}
      >
        {/* Botón X para cerrar */}
        <IconButton
          onClick={() => setModalCampanaEmergenteOpen(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.9)",
            },
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ p: 0 }}>
          <Box
            component="img"
            src="/VENTANA-EMERGENTEv2.png"
            alt="Publicidad"
            sx={{
              width: "100%",
              height: "auto",
              display: "block",
              borderRadius: 2,
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Inventario;
